import { optionTitle_composeAssistance } from './ComposeAssistanceOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import shouldShowTextPrediction from 'owa-proofing-option/lib/utils/shouldShowTextPrediction';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));

let ComposeAssistanceOption: LazyOption = createLazyOption(
    {
        key: 'composeAssistance',
        titleStringKey: optionTitle_composeAssistance,
        searchTermsStringKey: optionTitle_composeAssistance,
        isHidden: () =>
            // This code is duplicated to the file isSmartComposeEnabled. WI to remove it 51333
            !shouldShowTextPrediction(),
    },
    lazyFullModule,
    m => m.default
);
export default ComposeAssistanceOption;
